// El proveedor de «sobre qué estás trabajando» (3.5). Solo esto, porque un
// fichero que exporta un componente y además funciones rompe la recarga en
// caliente; lo demás vive en `where-i-am.ts`.

import { useMemo, useState } from 'react'

import { WhereIAm, type Focus } from './where-i-am'

export function WhereIAmProvider({ children }: { children: React.ReactNode }) {
  const [focus, setFocus] = useState<Focus>(null)
  const valor = useMemo(() => ({ focus, declare: setFocus }), [focus])

  return <WhereIAm.Provider value={valor}>{children}</WhereIAm.Provider>
}
